// @ts-nocheck 87ce27c3
export default {
  invalidateViewCache() {
    const editorAPI = this.getEditorAPI();
    const componentId = editorAPI.selection.getSelectedComponentId();
    editorAPI.dsActions.wixapps.classics.invalidateComponentViewCache(
      componentId,
    );
  },
};
